import { ApplicationRole } from './models/role.model';
import { TransactionStatus } from './models/transaction-status.model';
import { QuickActionModel } from './models/dashboard.model';
import { profileSummary } from './models/profile.model';
import { IconType } from '../icons/icons.component';
import { LoanCandidatesSummary, LoanGroupDetails } from './models/loan.model';
import FVSConstants from './models/nav-item-v2.constants';

export const Permissions = {
  //
};

export const MeansOfIdentification = [
  {
    type: 'VOTERS CARD',
    expires: false,
  },
  {
    type: 'DRIVERS LICENSE',
    expires: true,
  },
  {
    type: 'INTERNATIONAL PASSPORT',
    expires: true,
  },
  {
    type: 'NIMC',
    expires: false,
  },
  {
    type: 'NATIONAL ID CARD',
    expires: false,
  },
];

export const EncryptionParams = {
  SALT: 'd10ff9ceacd08d99c1302d81a1d52557',
  IV: 'd186fba6a3dc18f670f6ebcebb68dba2',
  KEYSIZE: 128,
  ITERATIONCOUNT: 1000,
  PASSPHRASE: 't3@mApt123',
};

export const ApplicationRoles: ApplicationRole[] = [
  { name: 'OUTLET_MANAGER', moduleRoute: 'outlet-manager' },
  { name: 'MONNIFY_AGENT_MANAGER', moduleRoute: 'outlet-manager' },
  { name: 'MONNIFY_AGENCY_BANKING_AGENT', moduleRoute: 'business-user' },
  { name: 'MONNIFY_AGENCY_BANKING_STATIC_AGENT', moduleRoute: 'business-user' }, // Temporary Added
  { name: 'MONNIFY_AGENCY_BANKING_AGGREGATOR', moduleRoute: 'aggregator' },
  { name: 'MONNIFY_AGENCY_BANKING_SUB_BRM', moduleRoute: 'aggregator' },
  {
    name: 'MONNIFY_AGENCY_BANKING_SUPER_AGGREGATOR',
    moduleRoute: 'super-aggregator',
  },
  {
    name: 'MONNIFY_AGENCY_BANKING_SUPREME_AGGREGATOR',
    moduleRoute: 'supreme-aggregator',
  },
  {
    name: 'MONNIFY_AGENCY_BANKING_GENERIC_STAFF_USER',
    moduleRoute: 'Staff-user'
  },
  {
    name: 'MONNIFY_AGENCY_BANKING_BUSINESS_ADMIN',
    moduleRoute: 'Staff-user'
  },
  {
    name: 'MONNIFY_AGENCY_BANKING_CLUSTER_MANAGER',
    moduleRoute: 'cluster-manager'
  }
];

// export const KycStatuses = ['ALL', 'PENDING', 'AWAITING_APPROVAL', 'APPROVED', 'REJECTED'];
export enum KycStatuses {
  ALL = 'ALL',
  PENDING = 'PENDING',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum AgentStatus {
  ALL = "ALL",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  AWAITING_APPROVAL = "PENDING_BACK_OFFICE_APPROVAL",
  APPROVED = "APPROVED",
}

export enum LoanLiveLinesAction {
  REQUEST_LOAN = 'REQUEST_LOAN',
  DISBURSE_LOAN = 'DISBURSE_LOAN',
}

export enum KycWizardStatuses {
  VERIFICATION_DOCUMENT = 'VERIFICATION_DOCUMENT',
  BVN_VERIFICATION = 'BVN_VERIFICATION',
  NEXT_OF_KIN = 'NEXT_OF_KIN',
}

export enum KycWizardTitle {
  BVN_Information = 'BVN Information',
  Next_of_Kin = 'Next of Kin',
  Passport_Photo = 'Passport Photo',
  ID_Card = 'ID Card',
  Signature = 'Signature',
  Utility_Bill = 'Utility Bill',
  Agent_Address_Info = 'Agent Address Info',
}

export enum MeansOfId {
  DRIVERS_LICENSE = 'drivers license',
  INTERNATIONAL_PASSPORT = 'international passport',
}

export const Base64Delimiter = 'data:image/jpg;base64,';

export enum MerchantPricingStatus {
  ON = 'ON',
  OFF = 'OFF',
}

export enum RequestStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum QuickActions {
  // DEPOSIT = 'Deposit',
  TRANSFER = 'Transfer',
  FUND_WALLET = 'Fund Wallet',
  CASH_OUT = 'Cashout',
  CASH_BACK = 'Cashback',
  AIRTIME = 'Airtime',
  PAY_BILLS = 'Pay Bills',
  PAY_CODES = 'Pay Codes',
  COLLECTIONS = 'Collections',
}

export const AgentDashBoardSummaryCard = [
  {
    title: 'moniepoint.wallet_balance',
    accountNumber: '---',
    bankName: 'Moniepoint',
    balance: 0,
    icon: 'rolez-icon',
    shortMsg: 'moniepoint.short_note',
    loading: true,
    error: null,
    id: 0,
  },
  {
    title: 'moniepoint.protected_account',
    accountNumber: '---',
    bankName: 'Moniepoint',
    balance: 0,
    icon: 'rolez-icon',
    shortMsg: 'moniepoint.short_note_protected',
    loading: true,
    error: null,
    id: 1,
  },
  {
    title: 'moniepoint.promotion_commission',
    accountNumber: '',
    bankName: '',
    balance: 0,
    icon: '',
    cashBackEnabled: false,
    shortMsg: 'moniepoint.promotion_note',
    loading: true,
    error: null,
    id: 2,
  },
];

export const FundWalletModalContent = [
  {
    title: 'Fund Wallet',
    accountNumber: '---',
    bankName: 'Moniepoint MFB',
    instruction: 'Instructions on how to fund your wallet ',
    icon: 'rolez-icon',
    shortNote: 'To Top-up your wallet,' + ' simply make a bank transfer to your unique reserved account' + ' with the desired amount.',
  },
  {
    title: 'Fund Protected Account',
    accountNumber: '---',
    bankName: 'Moniepoint MFB',
    instruction: '',
    icon: 'rolez-icon',
    shortNote: '* Protected transfers should be sent to this account number',
  },
];

export const QuickActionCard: QuickActionModel[] = [
  {
    action: 'Cashout',
    translation: 'moniepoint.cashout',
    icon: 'cashout',
    featureAccess: 'show_cashout',
  },
  // {
  // 	action: 'Deposit',
  // 	translation: 'Deposit',
  // 	icon: 'deposit',
  // 	featureAccess: 'show_deposit'
  // },

  {
    action: 'Transfer',
    translation: 'Transfer',
    icon: 'transfer',
    featureAccess: 'show_deposit',
  },
  // {
  // 	action: 'Fund Wallet',
  // 	translation: 'moniepoint.fund_wallet',
  // 	icon: 'fund-wallet',
  // },
  {
    action: 'Airtime',
    translation: 'moniepoint.airtime',
    icon: 'airtime',
  },
  {
    action: 'Pay Bills',
    translation: 'moniepoint.pay_bills',
    icon: 'pay-bills',
  },
  {
    action: 'Pay Codes',
    translation: 'moniepoint.paycodes',
    icon: 'paycodes',
    featureAccess: 'access_offline_payments',
  },
  {
    action: 'Collections',
    translation: 'moniepoint.collections',
    icon: 'collections',
    featureAccess: 'access_offline_payments',
  },
];

export class UserAlias {
    static staticAgent = 'MONNIFY_AGENCY_BANKING_STATIC_AGENT';
    static agent = 'MONNIFY_AGENCY_BANKING_AGENT'; //business User
    static staffUser = 'MONNIFY_AGENCY_BANKING_GENERIC_STAFF_USER';
    static staffAdmin = 'MONNIFY_AGENCY_BANKING_BUSINESS_ADMIN';
    static staffAuditor = 'MONNIFY_AGENCY_BANKING_BUSINESS_AUDITOR';
    static staffSuperAuditor = 'MONIEPOINT_BUSINESS_SUPER_AUDITOR';
    static staffCashier = 'MONNIFY_AGENCY_BANKING_BUSINESS_CASHIER';
    static staffAccountant = 'MONNIFY_AGENCY_BANKING_BUSINESS_ACCOUNTANT';
    static staffBusinessManager = 'MONNIFY_AGENCY_BANKING_BUSINESS_MANAGER';
    static agentManager = 'MONNIFY_AGENT_MANAGER'; // busniess owner
    static aggregator = 'MONNIFY_AGENCY_BANKING_AGGREGATOR'; //BRM
    static clusterManager = 'MONNIFY_AGENCY_BANKING_CLUSTER_MANAGER';
    static consumerOwner = 'MONIEPOINT_CONSUMER_OWNER';
    static areaManager = 'MONNIFY_AGENCY_BANKING_AREA_MANAGER'; // state cooridinator
    static superAggregator = 'MONNIFY_AGENCY_BANKING_SUPER_AGGREGATOR'; // // super cooridinator
    static supremeAggregator = 'MONNIFY_AGENCY_BANKING_SUPREME_AGGREGATOR'; // // supreme cooridinator
    static personalBankingOwner = 'MONIEPOINT_PERSONAL_BANKING_OWNER';
    static subBRM = 'MONNIFY_AGENCY_BANKING_SUB_BRM';
    static kioskMarketer = 'MONNIFY_AGENCY_BANKING_KIOSK_MARKETER';
    static marketer = 'MONNIFY_AGENCY_BANKING_MARKETER';
}

export const TransactionStatuses: TransactionStatus[] = [
  {
    key: '',
    value: 'All',
  },
  {
    key: 'PENDING',
    value: 'Pending',
  },
  {
    key: 'COMPLETED',
    value: 'Completed',
  },
  {
    key: 'FAILED',
    value: 'Failed',
  },
  {
    key: 'IN_PROGRESS',
    value: 'In Progress',
  },
  {
    key: 'PENDING_REQUERY',
    value: 'Pending Requery',
  },
];

export interface CardStep {
  step: number;
  title: string;
  note: string;
  icon: IconType;
}

export const CardSteps: CardStep[] = [
  {
    step: 1,
    title: 'moniepoint.request_debit_card',
    note: 'moniepoint.get_started',
    icon: 'card-step-I',
  },
  {
    step: 2,
    title: 'moniepoint.collect_card',
    note: 'moniepoint.delivery_time',
    icon: 'card-step-II',
  },
  {
    step: 3,
    title: 'moniepoint.activate_debit_card',
    note: 'moniepoint.activate_card_note',
    icon: 'card-step-III',
  },
];

export interface CardAction {
  title: string;
  action: string;
  note: string;
  icon: IconType;
  directionIcon: boolean;
}

export const CardActions: CardAction[] = [
  // {
  //   title:'moniepoint.card_channels',
  //   action:'CARD_CHANNELS',
  //   note:'moniepoint.manage_atm',
  //   icon:'card-channel',
  //   directionIcon:true
  // },
  // {
  //   title:'moniepoint.card_trans_limit',
  //   action:'CARD_TRANS_LIMIT',
  //   note:null,
  //   icon:'card-limit',
  //   directionIcon:true
  // },
  {
    title: 'moniepoint.change_card_pin',
    action: 'CHANGE_CARD_PIN',
    note: null,
    icon: 'change-card-pin',
    directionIcon: true,
  },
  {
    title: 'moniepoint.block_card',
    action: 'BLOCK_CARD',
    note: null,
    icon: 'block-card',
    directionIcon: false,
  },
];

export const EmptyPicture =
  'data:image/png;base64,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';

export const ProfileContent: profileSummary[] = [
  {
    title: 'moniepoint.personal_information',
    action: 'UPDATE_PROFILE',
    actionName: 'moniepoint.update_profile',
    loading: true,
    error: null,
    content: [
      {
        nameOne: 'moniepoint.first_name',
        valueOne: '---',
        nameTwo: 'moniepoint.last_name',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.email_address',
        valueOne: '---',
        nameTwo: 'moniepoint.phone_number',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.address_line_one',
        valueOne: '---',
        nameTwo: 'moniepoint.l_g_a',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.city',
        valueOne: '---',
        nameTwo: 'moniepoint.state',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.address_line_two',
        valueOne: '---',
        nameTwo: '',
        valueTwo: '',
      },
    ],
  },
  {
    title: 'moniepoint.next_of_kin_information',
    action: 'UPDATE_NEXT_OF_KIN',
    actionName: 'moniepoint.update_information',
    loading: true,
    error: null,
    content: [
      {
        nameOne: 'moniepoint.full_name',
        valueOne: '---',
        nameTwo: 'moniepoint.relationship',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.email_address',
        valueOne: '---',
        nameTwo: 'moniepoint.phone_number',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.address_line_one',
        valueOne: '---',
        nameTwo: 'moniepoint.l_g_a',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.city',
        valueOne: '---',
        nameTwo: 'moniepoint.state',
        valueTwo: '---',
      },
      {
        nameOne: 'moniepoint.address_line_two',
        valueOne: '---',
        nameTwo: '',
        valueTwo: '',
      },
    ],
  },
];

export const HouseType = [
  {
    key: 'DUPLEX',
    value: 'DUPLEX',
  },
  {
    key: 'BUNGALOW',
    value: 'BUNGALOW',
  },
  {
    key: 'MANSION',
    value: 'MANSION',
  },
  {
    key: 'ONE STOREY',
    value: 'ONE STOREY',
  },
  {
    key: 'TWO STOREY',
    value: 'TWO STOREY',
  },
  {
    key: 'THREE STOREY',
    value: 'THREE STOREY',
  },
  {
    key: 'CONDO',
    value: 'CONDO',
  },
  {
    key: 'FLAT',
    value: 'FLAT',
  },
];
export const HouseColor = [
  {
    key: 'WHITE',
    value: 'WHITE',
  },
  {
    key: 'BLACK',
    value: 'BLACK',
  },
  {
    key: 'CREAM',
    value: 'CREAM',
  },
  {
    key: 'GREY',
    value: 'GREY',
  },
  {
    key: 'RED',
    value: 'RED',
  },
  {
    key: 'GREEN',
    value: 'GREEN',
  },
  {
    key: 'BLUE',
    value: 'BLUE',
  },
  {
    key: 'BLACK',
    value: 'BLACK',
  },
  {
    key: 'YELLOW',
    value: 'YELLOW',
  },
  {
    key: 'ORANGE',
    value: 'ORANGE',
  },
  {
    key: 'BROWN',
    value: 'BROWN',
  },
  {
    key: 'PURPLE',
    value: 'PURPLE',
  },
  {
    key: 'GOLD',
    value: 'GOLD',
  },
  {
    key: 'LEMON',
    value: 'LEMON',
  },
];
export const MajorLandmark = [
  {
    key: 'BUS STOP',
    value: 'BUS STOP',
  },
  {
    key: 'ROAD BLOCK',
    value: 'ROAD BLOCK',
  },
  {
    key: 'POLICE STATION',
    value: 'POLICE STATION',
  },
  {
    key: 'BILL BOARD',
    value: 'BILL BOARD',
  },
  {
    key: 'SCHOOL',
    value: 'SCHOOL',
  },
  {
    key: 'CHURCH',
    value: 'CHURCH',
  },
  {
    key: 'MOSQUE',
    value: 'MOSQUE',
  },
  {
    key: 'BANK',
    value: 'BANK',
  },
];

export class Screens {
  XtraXtraLarge?: boolean;
  XtraLarge?: boolean;
  Large?: boolean;
  Medium?: boolean;
  Small?: boolean;
  XtraSmall?: boolean;
}

export const ScreenSizes = [
  {
    name: 'XTRA_XTRA_LARGE',
    value: 1600,
  },
  {
    name: 'XTRA_LARGE',
    value: 1200,
  },
  {
    name: 'LARGE',
    value: 992,
  },
  {
    name: 'MEDIUM',
    value: 768,
  },
  {
    name: 'SMALL',
    value: 576,
  },
];

export interface CustomArrayModel {
  label: string;
  value: any;
  isAmount?: boolean;
  isDate?: boolean;
  isStatus?: boolean;
  isButton?: boolean;
  isSubmit?: boolean;
  isSelect?: boolean;
  isSwitch?: boolean;
  buttonName?: string;
  extraProps?: string;
}

export const ProfileUsage = ['Agency Business', 'Non Agency Business', 'Both Agency and Non Agency Business'];

export const OtherBusiness = [
  'Agriculture',
  'Construction',
  'Education',
  'Fashion and Beauty',
  'Financial Service',
  'Food and Drinks',
  'IT/Electronics',
  'Sales and Trading',
  'Travel/Hospitality',
  'Others',
];

export const SurveyOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];

export const LoanGroupStatusData = ['N_A', 'approval_in_progress', 'active', 'default', 'recovery', 'terminated'];

export enum ModalActions {
  OPEN = 'OPEN',
  CLOSE_LOAN_GROUP_INFO = 'CLOSE_LOAN_GROUP_INFO',
  CLOSE_CREATE_LOAN_GROUP = 'CLOSE_CREATE_LOAN_GROUP',
  CLOSE_LOAN_GROUP_SEARCH = 'CLOSE_LOAN_GROUP_SEARCH',
  CLOSE_LOAN_GROUP_SEARCH_AND_RELOAD = 'CLOSE_LOAN_GROUP_SEARCH_AND_RELOAD',
  CLOSE_CREATE_LOAN_GROUP_AND_RELOAD = 'CLOSE_CREATE_LOAN_GROUP_AND_RELOAD',
  CLOSE_RELOAD = 'RELOAD',
}

export const LoanGroupDetailsData: LoanGroupDetails = {
  dateCreated: '2021-10-20T11:34:07.000+0000',
  groupAdmin: 'Idris',
  code: '564567890',
  memberCount: 3,
  groupManager: 'Chidera',
  name: 'Avengers',
};

export const LoanCandidatesSummaryData: LoanCandidatesSummary = {
  belongsToGroup: false,
  groupHasReachedQuorum: false,
  eligibleToJoinGroup: false,
  eligibleToCreateGroup: false,
};

export const EmploymentStatus = ['EMPLOYED', 'UNEMPLOYED', 'SELF_EMPLOYED'];

export const MaritalStatus = ['SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED'];

export const LOGINDATA = {};

export const DEFAULT_FEATURES_NAMES = {
  PAYCODE: 'pay code',
  COLLECTION: 'collection',
};

export const HIDE_FEATURES_NAMES = {
  INWARD_TRANSFER: 'Inward Transfer',
  DEPOSITS: 'deposits',
};

export const AGENCY_FEATURES_NAMES = [
  'withdrawal',
  // 'deposits',
  'pos transfer',
];

export const MERCHANT_FEATURES_NAMES = ['purchase', 'transfers'];

export const GENERAL_FEATURES_NAMES = ['pos transfers', 'card transfers', 'airtime', 'bill payments', 'overdraft'];

export const MONNIFY_FEATURES_NAMES = ['pay code', 'collection'];

export const MONNIFY_TERMINAL_FEATURES = [
  {
    name: 'WITHDRAWAL',
    description: 'Make use of your terminal as a cash withdrawal point for customers having an ATM card',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAADAAAAArCAYAAAA+EwvfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALUSURBVHgB7ZnPbxJBFMffm0WwS2MbTdWLLQdPRr30aE2806sX+Qvq2UO5caueTax6x4tX4z9A/wH1ZNJDgYsIGmhkl187z/cWSC2WJixDlk32kyw7zC4w33m/ZliEM1QmU0i27Z8J8lYRlhC0/lDauTk4OSl0+S35ffKyvf3uSsX9klrWgV9E43uzA/C+b3Fb9a/ds4GSkRm8kL513XLqTwa+20AEIc9ByEBStW1IQETZ4LErX0lEkbEriDixgLCJBYRN5AUEqgEdG7MaYQ1MonXVdrEEMxJIAKF+xcVjEwzCCb3Ip5kFxDEQNgbWQVgiwgMIAKJ+C3O64twWQKCK7dARnx8T6VNpyzG69lAO5XnVcT+CXldAW+N75sWcCyHlLcQH0nRtnefZ/cx9L+WgBH7r2F5ueB9mCeEZGCKogPK0C65NuzzIPAK+SQ3wDnrqPneXCNVhJ6W3pn4jYSCLBBKgNeT51Jrs503qJiLuyLWrbdhXXT53qMJC/BknS2WnfGUZ9Ow1QAgkIO3iV57ZRwT4SQOeE8IipMC1pnx0ovhheWSpHREKAQichUY/+J8vE8ERIuQkDlYc5WenrqWf+yHNGYtfc+N7V9qQhTkxXgdsRyoqFiUO3DRV5ZA2+/iBqczzLwvZD/PM7jk2iiUkHtgqWFzE4AWTAs75sFiC3Wht2FYLGbyw2KWEuA6isZx/EWYFIOU6aTrUqWG2kUzFGcYPVKkBHA8f2KF2wSCmLbDJaTTXs8AfpGQqqQXS5hoglpB+o/sIkzEg1dlfmBEvH9w07E9cXx83ZP00+lt2bowJYHfZI3WW4y+hlfT8zYsRjAkYFbZAy+p5iHdkYRMLCJtYQNgoefIHEcVqaq3qPasPEaVWW+0rOH7dw9925KxgNTc0QKEnMUD1OjiNdn8AEaFx2vRqtReOtCdWVE8tuHs7AYMby/ngL/GL4PgHT/RHb9z1FwowEoi8yP/xAAAAAElFTkSuQmCC',
  },
  {
    name: 'DEPOSIT',
    description:
      'Make use of your terminal to help facilitate transfer of funds for your customers to a 3rd party account and collecting payment in form of cash from your customer',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKeSURBVHgB7Zk/b9NAFMDfO5+dtEnTDixFDTAgIbVsSFTtxFKUjaFQvkYldvoJKrFXgj10YcvGRDqxkUwskEgsDM2fpk1s3+OeG6sQUCBnx8RqfoN9OVny7053772LEYbcef8o6/q9nPR8B2YIT1oDXLR6ze2T87AP+XLj3b2lXCafhxnmrJ/tfn/yocNtXKtuLVjtwQqkAL/gnPKMC+r5i5ASQlcxa2t4HKGrgBQyl06KuXRSpFJagiEuuQXZx+eEVIAJQcuqoBQ1MMRI2ne9olR0DEhFhMkR5DcIzKWNlockta5vRTABxQHZdhkiYCStEJfBABR4iI484jb13T0wJLGNyMJg24fcvhSmF2BIrNKBmCV3dMH7aeQtR6Ew9L0tLfwKIhDvTCNWg6hAUL/qgzLazgE3yVMbBPQGIjLt5VHzbHzJDY444HuvtfrEIXKUWKUVwc8btOE5uGuj3WZhodQxmEacEeJd02o4iwKrSoin0xBmjDPiOFDHYQuGWVORXhLxCTNTkQ6xPNrWIaWsM2dLCGoRiTb5iiNHpEFMVVrYTiVs0/COalAj+g/SqFDXDvRbv+4rwYWqoVQFIgrESEERhV7rSm9ShHX90H2ISKwzrYunEqBXIv+XPh1Whj8IYuE6HwKwrS+N8Y+MpPYIRJfWdYXnwEOOy5yy//BEQ8ftfXScx2iJXfjb4P7pleZwAtnkuoKTiGXLhhbb575LeWxzAaWz4g6G9bOUJ5hxNoNBEDTBELxdebAKKeJL6eO3+Wk8KebSSTGXTop0SqMvYipjpo+wZVB6CTeDLqQEd0EErmJ5tduBlNBsrrX4Luob9QF/6oIZpuef00123HsbVOpXf3qWn1l3819zFyudqR7BJiV7uuR97t46C4WZHx4h6bsGCcx4AAAAAElFTkSuQmCC',
  },
  {
    name: 'PURCHASE',
    description: 'Make use of your terminal as a payment point for goods purchased at your store by customers with their ATM  cards',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAACwAAAArCAYAAAADgWq5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJCSURBVHgB7ZmxbtNAGMe/77vYJaGNy0AlJCzW8gQI9kosMKA0A09RqQMbnRnyAIg3SGFhArFT8QBIHZGSqQNUaUmL7buP71CRAmmT2r6rYtU/KXF8vig/n/93udMhnDHY7DeP04NWk4IQFogTkybLwdo43u2e2HO0b/tPX63caKwuwwJzmh0er79/cYS2ZbX+sQoVQKlbh2RjABXButKiZXYW1pWgYtTCvqmFfVM54QYUxBgTKzTbgHg31xeZh8TU00QDKEBhYUJ+y4AxMOQEQRPbm+xAAQpFQlH2UA4xFIXhkZInBAW4PhmeYNBAfMmMo3kVNZh3UJLSwswQaZSO1ICZwkZzO3/epyktjAhtkf6kMwc2l8BFJKTf4xtGM7OFmSlG4C6UxEmGGWlnXv+VJyHS+rEc2lACF8IyFusvl6lYVtbiJBL/I2mOXMidh5NIAKoHkwWh0u00g33wgJtIQLY9WZBkfzoY+MBNJBj/EfYla6nnw765HsJpRsPJc/lT+Mx2tLiYwdT1vBP/M0q1sEiM5LXDoDphAzak8/WmK2Ev0LCBMvQh09acG5uL2rr/ZAVywsyRrDiiQONzo9SeLTNMv6TV9gxDHxFjafUDxdhhog+G5JoF8atMlD7KMSKQz4jDvL+N3569vgMVoh4lfFML+6YW9g39PL2i1aMDmkskQ3rIKVSEJWwltB6sHUFFiNJgRLjbTe7JdhIsMDa2dstLXDX+LeTNvvoeJjfHSehlYVoEM0652QrS27IhamVt2W9QlL9qJRdJQwAAAABJRU5ErkJggg==',
  },
  {
    name: 'TRANSFERS',
    description:
      'Make use of your terminal to help facilitate transfer of funds for your customers to a 3rd party account and collecting payment in form of cash from your customer',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQuSURBVHgB7ZlvaBtlHMe/z93lf9MopXMtzVSYVbcqaMZk4j+cYiubA9c/Vp3YYesfCusWxReCrANfaVXGULdpN3FQXJgyi7NlDjZwiUI2Xxj7Ynu3gHUVwSRNY3L33O2eSy7ttrTjrpcugX4gyXPPkz8fnvs9v/s9FwKdVxUn5JQHMm9HJcHRHOq8M/iEZPQuoj1v/8eLnLsGlYx9ZhrD9SnW5NChuCpemMEcd6quYNKulBvVwr95V67iYnghCq4cqpBl6aViWXqpELAI9r6QWbtmJW1l7Sk17a/wzo6lcyS+5TPPUZQBgpfTDTDBaH+6s9FH93AEtex48xdO9D0iYnMLLb6Hyoh//7ut/YOfXHFYxRHPpKnw+HkgGWy6hX6qC08miPYY/NGO10cc+CuRrw54Dv72gPjb8bdSnbAQw9JMuK4GQV2WSbJZ1jl3icNz6vGBs7ZiX9Otyh5YiCHp99oy/muFmWQpDvwiYCSaXzLsjHSso7WwCEMLcXUDmvT23DC4lgafgt3P5rQacjTGa3131GdPvtM2+5576pXI2ITz/VCUT6Kc0jpMhAkHVsnoXiehsVbGi4ed8DoVdAckbLqP4uBZAaN/XPX1/rkHXofi39eViYeiNUMwiCnp82pI7O/OajN5+gKPxhYZT9xFsWujiDMXebx02IHU/2TB70hlCbIi8cMEpqR3PSlh8IQNpy/mT31gFUVQFd59wq7FOJtxdhbmi/fFYkp65BxfFGa8/Z2j2H5lvZTsCtChqWk+JlKp66NTQueFy9bKG5LuGXZFjr2JHkA5VGqchcim+7GjdW/NeKErcvyNFJ7/ynlz8/TWz13j84013yZfN84JXLhRzSZWYul5Y4uP1SNz+7wOeW0qC0uxVJpdTHxuefhjVZxdTEJ96dZvzwu9N8okRllUlVeK7d/Y/Wpsn2zw5fDhKUHLIM0rFHQ8SGNjE1yLnlFYdiFQ/oQJLJdm6JmFpb7+x6XkQ7fTg9u+9sSCT80cYj+5bb0Uj17ij/aNOMIwgSlpuwB26V2wlmAz2f+YOP7uD/bYvjN8L4g09uhqDNS5pOSOY/YNREGQUmKq3jYl3XavPJSTxMHJROklsfFuGp+4TL7sOeJ8Rk2PwUL3hi37HWvUkGhhEX5nnRx5oElIhKIwjOlNAFtozfU5X6mx4V+F16am0TvfZ9UEGJcpaYcsGN8cqJsA0zGdr85cJSs0wSaq/Yr6ICVCiIRlip2mhAuUpTiQRNsQpdzTarMYs2x2ofBbqSi0L0aYUZbsoaGKqXvEAU6QwoQoD0MhYSpxEVhA+aQLyJLAZtvSXfnyzZqlYll6qahS6axibYVeTqhbZi/qfy6yiGrBDc2VQ8abQrWQRIK9cAiRHLLu/1DJsBBmjiGi3ZKd3Qd1KDxWwoOZ8l8lDeGGhL+R1oUZVwCjWYD1M+CEVAAAAABJRU5ErkJggg==',
  },
  {
    name: 'CARD_TRANSFERS',
    description: 'Make use of your terminal to transfer funds from your customers ATM card to a 3rd party account',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHcSURBVHgB7Zi/TsJAHMe/d20BE5VZE+EJcJGRBGZ0ZsAncWP0FXwA4xPA6mDccMG4msgioyAJlLOtd4UGxITws39oYz/DcSU9+OTy+/3u1zJ43Ds6xk8Z2FMNcYLnLBxBoFwW3lfMHTudLMRhBnHGGM1Qr5tqynHTNWIvrFCOXekKJX0MA0nhHQvpuMXwJhauHAkklY6KVDoqUumoSKS0Dio5VODY13J2Cv/08GVdwjLeKItoO62JohS+QzDCcH9H19owRJ6yiCZtGCdyJP3BFhSgZQuUBbTwsGYjcP0BO4YmLTI9OZ4jcGzS3f+geqhE1LQmgobxW5job3s7TVolomNfIWhsqDwJSXodxj4Ap+3OHaaqSklOiggZf9IOq8Bkyx3KyvIF5xHBl8Uf+EnE/q84nF8PETJ+pPNuYq4yvyYdFH/BT3jk3SNYt1f6Bi2o430j/mJ6vquh7+w6tPCwxDOCjllVgfj25U5BkxbGUNZUeYwzUiu5AdkWsCblYFHQw0Nw1X+UvNeAuyB93IqKVDoqUumoSKWjgsMUDpLCwpVj74D2KLxLFq4ck1cTSeHibKI+OBoNC4OXKeKMCotBbio7Qjc8ll1Pq8VRrWYwPohXcu5/2qjVTE9Y8Q2DB3lWISDyOwAAAABJRU5ErkJggg==',
  },
  {
    name: 'AIRTIME',
    description:
      'Make use of your terminal to purchase airtime to any registered nigerian mobile number for customers having an ATM card',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKoSURBVHgB7Zm/b9NAFIDfe+ckjmhUEAsC0SBmkiWMVOpKy8xQBphAYWAuW7cwM6TiD6ALIw2MIBU2OpWJAYlIsCFICMSOc/e4c2KaX2KwHStR/UmJfc+W9fnu/N7FQRjyZoOtT4WjrIUrAhaIPnckfAPvwdF1L4ih+Xp681XuTOZqFhaY397n3qPXm67Zx2eVDxnr0ooNS0D/a8cxPU5wETKwLAxdadHm8P8IXAmWkFQ6KVLppEilk+IUSQurqCj3UQm7/e9j2p5YhQQIJ83WZUBcG4uZdoZuTZ0q7L3Jm4OIhJJm6rdnxpGmeloR1ohhU+8e+IHJmw1BOGngLzMvRliajAmv25QEZgRuQCAekVDS1Jctbd6cjDPDlLQU+T1k2GYBWyC5ATFgQUh0bx8g4MPRGDLvj7Z9YeAtIyx6zrGyRJM49xMiEjrlIauxXkPkGrJbH7s4cysQ9ttmhOSfyL0dWprYO9Sqh0FbMbUmz0Hl7ATCcRKpuDBBVXe5L6unwWMGqwwJEEnaZAb98NWGzVUmsW8Kz+g5iN5ZRLtkthATkcu4kG5dP4CDuaxzsALrnRK5O4ODVlHiSkOnvPeSCk1Ftj6WbzDZTyACobPHKKjcHaCcLi5+NtEFBnUVzG/rmV7WN3JScBDKft5BWFeZfN2MFIQgtgWTEdc9XjuJ8LqOzmUtEusqT4vXmPCafgP0HOZI7EtTM+QoneqI/MySbyGHHoVY5vQshvO1at67YdYuseQ1yeCnRERocs8Nnb/nJj0KDwrMsX7TEsvaI/25lRSpdFKk0kmRSicFOTldp5aEwtCVLKerYEn4MXSlc3bFhSXh/stK12zp9guU5q8uWGCctuT+hY6jX1n40wODA7uwS8WNu9le4ftCPZzZX+fVvbdX3EDY8BfTl/5Cq/dAIwAAAABJRU5ErkJggg==',
  },
  {
    name: 'BILL_PAYMENTS',
    description:
      'Make use of your terminal to make payment for bills towards any of our approved bill providers for customers having an ATM card',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKbSURBVHgB7ZlBaxNBFMffe5OEJqlpK1KwNLQHD4X2XupdyF3JNwgeFTx407OHgFeJtPeA936C+AWKeBBUGhBENI1NGnYz83yzm21iLSLTIWZpfpDs7uwk+WV5+58ZFmHE5sHHhbA3KGay+RzMEMPwLMDVxX67Wj5L2tC+3Xrx/kZxeWERZpheZ3D67enWT7uP683jvPqhlyEF6BXVsVec+OtpAVJC4kqzVsN/I3ElSCFz6Wkxl54WqZTOgCOaYY95eBccQKCmIjoGR5ykjdYVRrMPjhjQNXm75yruVB4GuQJXQCY8JWD37/hvNc3IJXDEizQDNpgLWwhqFxGPfj+L9Qxl15DhOXjCz5VmqmdV2LU1ioz18QkrnImPiY7AE16kiXg72ddoRokyFtbGlJnNS/CEc+RNYtgciNShlEZJyqBiS0GpTMOeY9TbkhZvENC5hi/iRTpKA4Aqs1Q30mNFqmnbrfBQ+xW2eE2PSBhjYTv4jIRP5NB5ILkMT+nBXRG+PxbWctVDEaaGJMeufTFC48LHyuCIF2kF6pEIv7X7sXB800mNt85/iNVr8IQXaeRM2241h7XJlDAwHvUYdBU84eVG1Bjso8ETBtiZbEfmmubh3uhwBzzhRVooS11fWqPS7k024fouAmx6+Ojzr1xJOoo6Gf2ylIsmS1LFrT97YcvGYdRHchw8ZLZTTUeyAHXgYkPJRMm2xRN6ejCKvCfyZ7oyKXmWRGHUR3KcsngYBLrG8SjqBG68+nQbUsTnh5tf5qvxaTGXnhZz6WmRTmkc9hhSAlHeRNuQKYSUEC4FkSstrcaPudJAG9btehPoXRUDvbLRgRmmLyW8Jo/joIraHuP5mSarO8H34iDX97Uw8MJCUBh+yN3sJcKWXyE0+iWn+FhjAAAAAElFTkSuQmCC',
  },
  {
    name: 'POS_TRANSFERS',
    description:
      'Make use of your terminal as a cash withdrawal point for customers who can transfer funds into the protected account linked to your business',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAC0AAAArCAYAAADsQwGHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJUSURBVHgB7Zkxb9NAFIDfu/MdzlDogFRRiQZVZSqwlDGVMhP+AQNz+guajQ1+An8gLF3pXgm6kSWMdEkGUKc28hDHZ9/xLsSRhwLq2bJs1Z/k+M4+O5+dd+/OMcIK0+16P4NASt/nUCGiMEx+AaiXo5FKt6H9+LG3d29za0tChbm+vIyeXlwsbBm/HRyItu/7UAMmYRjaO84eAQioCakrq1oM/4vUlUENaaTLopEui1pKe1AgEeebUohXBqBt6zTcjiOlzmWSXEOBFCZtWq0BnexIAzxYb6OFSzml9RDn8/dQEIVIk/ApiR2mdTRmvNyO+ILu9g7tG0CrBUWJ547pxPcHGeGhF8ePMQw7dvGS5JkNEbvDisdSHkIB5O+IiG9WpTGbz/taqVm6S0fRlMdxj4oTW+ecH0MB5JLWUi5/fls2Wn+4sQ1dhDHm07JNJoTykEsaEe9nTvTXDEExPl23k3IHcnK38rTNyYLzDhizrBvGXqPv33wXETtpUTPWSYQ450pNwBEnafrSNve8U4rVrOSRRvzvsdTmI3jeNAHouYo7hQfjvJ92QBfssYyxHjjiJI2ZUc8V6sTPwZFmllcWjXRZ3B1pys/fISfamK/giJM013pI5kNwhOYiXzytP4MjTiOinbkxpfpMiGNKuLfL2cbM7PEa3Mn15LKaO8+gZJrsURaNdFk00mXBjBAGakLqylQQ5MnzpZK6su3d3QXUhO3RaG7XDE9Okof0qgsqjLm6MpP9/RD//KcJ68fnd3QBb7tdKYOgUp0z2tjQT87OFqmw5TeZLtBpIszSyQAAAABJRU5ErkJggg==',
  },
  {
    name: 'PAY_CODE',
    description: 'Make use of your terminal as payment point for merchants to their customers who present unique codes.',
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAEcAAABFCAYAAAAYePsUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMSSURBVHgB7ZzNahNRFMf/k1RI1ELixtpuUu1KEYcGpRCxLQqCCK0LF67qyo2L+gZNX0CMb+BOV1bwARJpRPwc9/3Ixpidra0kUpPx3pkkzoTxdJLJLfk4Pxiaubkzix/nnrnntB0Nrej6HBBeBMwFQEtg8DHs49gqjHcF5xda85M+FwN+roihRxhatCfAHyHJ2LHOrDFLzF5WfLoERkRRdV4KCtnnMmJYTB0dGJE+ROToMwngYBtMC9q8iJyDNBgPaotCjsbLyRNtQcgxdTBeJEJg/gvLIWA5BCyHgOUQsBwClkPAcghYDgHLIWA5BCyHgOUQjEAhy6k9zE7+RixSI+c9+3zCOlxcvQacnQIiUfJafPogjvdQgTI5S9O/8PjWD19zZycriEVryORH7YHkFeD2HV/XNgXmc+g2ypbV0vR+W/OloCbJy2iLc1NQQc/knFjERMcctvQ6hBMyAcshYDkELIeA5RCwHAJlcnYqAW5dLqMXUCYnuxVpa76rfNjaRFv0W/nw9O0odkX0HLZTlhEmRbrkyFKgUrbLCAo5Z3NDmRwNejLA1nSw4YRMoLRl0WnbQRahy6l9UaWfRG67nrvkfeT91t+InLSBo0CdnABth5Xru1YfCDD/yblx054n/1Kv/+V00HZo6cl4VurxeF2SA0Wy1C6rdvDbdjgzATx46B6TS+31S3SbwUjIUTX9nN6JHL8Ui+4okXud4jeooCflkKWHlNH3CTkAjUZ7s+FOIXPQ9yGKHPn4bj7CKe7es7cMnJA9iJ+yf45PQAXqIidI26GxG3Y+3hUJoFAnR7YdLlz0P99ZWaeEmPM+rlXc91EnJ0jbIS9ySPS499z1nHueprnHugi3LAi4ZUHAcghYDgHLIWA5BCyHgOUQsBwClkPAcghYDgHLIZByCmA80Az5f+WvwHhgSjmhNTAeVFfDKBULGBsXv2PFDJgGGRhfntcTcjUN+w1EDPC17gNh67RUqmDs9AuxxGRHe5gjKCPE3He/ecmJrieEszTslw0NwUtAzILQIB5K2hqMj1nnN38BfIzQbpYuAOgAAAAASUVORK5CYII=\r\n',
  },
  {
    name: 'COLLECTION',
    description: "Make use of your terminal as payment collection point from monnify merchant's customers.",
    iconLink:
      'iVBORw0KGgoAAAANSUhEUgAAAEcAAABFCAYAAAAYePsUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKMSURBVHgB7dy/axNhHMfxz3Opg3ZpHbTqcq1uFTwoSjcbEXSy+QtEnB3cnKSpg7MFd3HTyRYcFBRTcFBa8Art3JskKGhQxEJNz+e5ayUmT7+k8jzm2nxecDR3DzTpu8/9ICGn0C6KpoBSBUinARXi4Ivz5dAs4ndJ64D68yiaGgK+zehNt9G31APgl44UN7K1bFsW5ntNPzoH0rOoWTaBgnzdzBiG2RYBA6aHnjnRZAhsroPaqLKeOZtVkMVWRcdR3J2s1LSOk0YgmzAA7YpxBIwjYBwB4wgYR8A4AsYRMI6AcQSMI2AcAeMIGEcwAB+Gj+bL//T1S7445D7O5St6uYqeePVCLy/hitvdysyWXoUxzHM7nLHu4/Saw9fg55izY+MnsLyU/2w3fhY4cQpF5jfO2irw/Jl97O0iUL2PIvN7KpfOHrbZVDC8zhEwjoBxBIwj8Btn7PTu1x0T51F0fk/lY2eAO3exX3G3EjCOgHEEjCPwekCOsI7XzRkM4UfH2GNVxs3gVsf2R1sPcT19g24kOJb9jkU1Dh+8zpyL6Zo1TDaGVev2a+l7dCvEp2zxxevMMbOjEQzqP+Bzx1gN9v/2pdI9VNIldKOBI1hQF+CL1zgNDGaB9mIFo1hRoygCt7uV4ze4/4nD1+A+jsM3uPfMPLfDOArRRArX+NGMwMML7QVeBAoYR8A4AsYRMI6AcQSMI2AcAeMIGEfAOALGETCOgHEEjCMwcRKQhYrN98oXQBapiRPMgyyasyXUPyYYOTms1yZBO+YQf3iyfUBuVpHfgYjMR2d5D5Sy1Xp9AyPHn+pd7DD6ewbN6TA3/r7zUqsoCnWzKvKbDfXBTUDSRGfQJyU1j3i51jryG3blkMF4p9PDAAAAAElFTkSuQmCC',
  },
];

export enum WEB_CHANNEL_EVENT {
  META_MAP_EVENT = 'META_MAP_EVENT',
  NOTIFICATION_EVENT = 'NOTIFICATION_EVENT',
}

export const DEFAULT_MODAL_KAMONA_CLASSES = 'moniepoint-dialog kamona-modal-alert';
export const DEFAULT_DIALOG_CLASSES = 'moniepoint-dialog';
export const KYC_CATEGORY_DIALOG_CLASS = 'kyc-category-sub-category-modal';
export const DEFAULT_MODAL_WIDTH = 396;
export const DEFAULT_DIRECTOR_MODAL_WIDTH = 576;
export const DEFAULT_FAILED_OTP_MODAL_WIDTH = 465;
export const MOBILE_CONTENT_MIN_HEIGHT = 'calc(100vh - 225px)';
export const CONTENT_MIN_HEIGHT = '100vh';
export const HIDE_ANT_MODAL_CLASS = 'hide-ant-modal';
export const SIDE_NAV_BREAK_POINT = 900;
export const BO_SETUP_SELCTION_MODAL_DIALOG_CLASS = `${HIDE_ANT_MODAL_CLASS} bo-setup-selction-modal-dialog`;
export const ACCOUNT_STATEMENT_DIALOG_CLASS = 'account-statement-modal';
export const ACCOUNT_STATEMENT_FAILED_DIALOG_CLASS = 'account-statement-modal-failed';

export enum MONIEPOINT_DESIGN_TYPE {
  MONIEPOINT_V2 = 'moniepoint_v2.0',
  KAMONA = 'kamona',
}

export enum MONIEPOINT_MODAL_BUTTON_EVENT {
  CLOSE,
  RELOAD,
  RESTART,
  SUBMIT,
}

export class CountDown {
  constructor(time, dayId, hourId, minuteId, secondId) {
    const countDown = setInterval(() => {
      const now = new Date().getTime();

      const distance = time - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (dayId && days) {
        try {
          const value = days < 0 ? '00' : `${days > 9 ? days : `0${days}`}`;
          document.getElementById(`${dayId}`).innerHTML = value;
          document.getElementById('day_label').style.display = 'block';
          document.getElementById('day_label_separator').style.display = 'block';
        } catch (err) { /* empty */ }
      } else {
        try {
          document.getElementById(`${dayId}`).style.display = 'none';
          document.getElementById('day_label').style.display = 'none';
          document.getElementById('day_label_separator').style.display = 'none';
        } catch (err) { /* empty */ }
      }
      try {
        if (hourId) {
          const value = hours < 0 ? '00' : `${hours > 9 ? hours : `0${hours}`}`;
          document.getElementById(`${hourId}`).innerHTML = value;
        }
        if (minuteId) {
          const value = minutes < 0 ? '00' : `${minutes > 9 ? minutes : `0${minutes}`}`;
          document.getElementById(`${minuteId}`).innerHTML = value;
        }
        if (secondId) {
          const value = seconds < 0 ? '00' : `${seconds > 9 ? seconds : `0${seconds}`}`;
          document.getElementById(`${secondId}`).innerHTML = value;
        }
      } catch (err) {
        clearInterval(countDown);
      }

      if (distance < 0) {
        clearInterval(countDown);
      }
    }, 1000);
  }
}

export const REWARD_IMAGE_MIN_ASPECT_RATIO = 2.7 as const
export const REWARD_IMAGE_MAX_ASPECT_RATIO = 3.0 as const

export const fvsConstants = FVSConstants;

export const POSNavConstants = {
  POS: 'POS',
  posTerminals: 'POS Terminals',
  terminalAssignment: 'Terminal Assignment',
  posInventory: 'POS Inventory',
  myRequests: 'My Requests',
  tcDashboard: 'T&C Compliance',
} as const;

export const USER_CONTEXTS = {
  AGENTS: 'agents',
  AREA_MANAGER:'area-manager',
  AGGREGATORS: 'aggregators',
  SUPREME_AGGREGATORS: 'supreme-aggregator',
  AGENT_MANAGER: 'agent-managers',
	SUPER_AGGREGATORS: 'super-aggregators',
} as const;
